import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { redirectTo } from 'omni-package-react-core';
import { useNavigate } from 'react-router-dom';
import { PersonalInformation } from '../../interfaces/PersonalInformation';
import { StyledSection, StyledButton, StyledDivButton, StyledP } from './Name.styles';
import Constants from '../../Constants';

export interface NameProps {
  personalInfo: PersonalInformation;
  withButton: boolean;
}

const Name: FC<NameProps> = ({ personalInfo, withButton }) => {
  const { t } = useTranslation('PersonalInformationsTile');
  const navigate = useNavigate();
  const infos = useMemo(() => ({
    firstName: personalInfo?.identification?.firstName ?? null,
    lastName: personalInfo?.identification?.lastName ?? null,
    initials: personalInfo?.identification?.initials ?? null,
    showSection: personalInfo?.identification?.behaviours?.showSection ?? null,
  }), [personalInfo]);

  if (!personalInfo) return null;
  if (!infos.firstName && !infos.lastName && !infos.initials) return null;
  if (infos.showSection === false) return null;

  return (
    <>
      <StyledSection name={t('nameLabel')}>
        <StyledP>{infos.firstName} {infos.initials ? `${infos.initials}. ` : ''}{infos.lastName}</StyledP>
      </StyledSection>
      {withButton &&
        <StyledDivButton>
          <StyledButton outline onClick={() => redirectTo(Constants.PersonalInformationsIntroductionPagePath, navigate)}>{t('modifyButtonLabel')}</StyledButton>
        </StyledDivButton>}
    </>
  );
};
export default Name;
